export default __webpack_public_path__ + "assets/m4a/1163b7ca71167d6b00781c049f46dfb8.m4a";